import { AxiosPromise } from 'axios';
import { apiService } from '@app/services/api.service';
import { IActiveFilter, OrderType } from '@app/models';
import { manageFilters } from './filters.service';

class SelectIdentitiesService {
    getData(
        url: string,
        order: OrderType,
        orderBy: string,
        top: number,
        skip: number,
        isReset: boolean,
        orgId?: string,
        onError?: Function,
        filters?: IActiveFilter[],
        expand?: string
    ): AxiosPromise {

        return apiService.get(url, {
            params: {
                $orderBy: orderBy + ' ' + order,
                $top: top,
                $skip: skip,
                $count: isReset,
                ...(expand ? { $expand: expand } : {}),
                ...(filters ? { $filter: manageFilters(filters, orgId) } : { $filter: manageFilters([], orgId) })
            },
            onError: onError
        })
            .catch();
    }
}

export const selectIdentitiesService = new SelectIdentitiesService();